export const AssistantArchitectureDiagram = () => (
  <div className="diagram-wrap">
    <svg
      viewBox="0 0 960 320"
      role="img"
      aria-label="End-to-end architecture: customer to digital channel to Bancony Assistant to Bancony Server to bank backend, with Langfuse anonymized signal"
    >
      <defs>
        <marker
          id="arrow"
          viewBox="0 0 10 10"
          refX="8"
          refY="5"
          markerWidth="9"
          markerHeight="9"
          orient="auto"
        >
          <path d="M 0 0 L 10 5 L 0 10 z" fill="#38B6FF" />
        </marker>
        <marker
          id="arrow-dim"
          viewBox="0 0 10 10"
          refX="8"
          refY="5"
          markerWidth="9"
          markerHeight="9"
          orient="auto"
        >
          <path d="M 0 0 L 10 5 L 0 10 z" fill="#9aa8bb" />
        </marker>
      </defs>

      {/* Boxes */}
      {[
        { x: 20, label: "Customer", sub: "web / mobile" },
        { x: 200, label: "Digital channel", sub: "iframe / WebView" },
        { x: 380, label: "Bancony Assistant", sub: "in-channel UI" },
        { x: 560, label: "Bancony Server", sub: "bank2ai runtime" },
        { x: 740, label: "Bank backend", sub: "core, IdP, APIs" },
      ].map((b) => (
        <g key={b.label}>
          <rect x={b.x} y="120" width="160" height="64" rx="12" fill={b.label === "Bancony Assistant" || b.label === "Bancony Server" ? "#0b1929" : "#fff"} stroke="#cdd6e3" />
          <text x={b.x + 80} y="148" textAnchor="middle" fontFamily="Raleway" fontWeight="700" fontSize="13" fill={b.label === "Bancony Assistant" || b.label === "Bancony Server" ? "#fff" : "#0b1929"}>{b.label}</text>
          <text x={b.x + 80} y="166" textAnchor="middle" fontFamily="Raleway" fontSize="11" fill={b.label === "Bancony Assistant" || b.label === "Bancony Server" ? "rgba(255,255,255,0.7)" : "#777"}>{b.sub}</text>
        </g>
      ))}

      {/* Arrows */}
      {[180, 360, 540, 720].map((x) => (
        <line key={x} x1={x} y1="152" x2={x + 22} y2="152" stroke="#38B6FF" strokeWidth="2" markerEnd="url(#arrow)" />
      ))}

      {/* Auth pass-through annotation */}
      <text x="290" y="100" textAnchor="middle" fontFamily="Raleway" fontSize="11" fontWeight="600" fill="#0b1929">Authenticated user context</text>
      <path d="M 200 110 Q 380 60 740 110" fill="none" stroke="#cdd6e3" strokeDasharray="4 4" />

      {/* Langfuse side arrow */}
      <rect x="380" y="240" width="160" height="56" rx="12" fill="#f6f9fc" stroke="#cdd6e3" strokeDasharray="3 3" />
      <text x="460" y="262" textAnchor="middle" fontFamily="Raleway" fontWeight="700" fontSize="12" fill="#0b1929">Langfuse</text>
      <text x="460" y="278" textAnchor="middle" fontFamily="Raleway" fontSize="10" fill="#777">anonymised signal only</text>

      <line x1="460" y1="186" x2="460" y2="238" stroke="#9aa8bb" strokeWidth="2" strokeDasharray="4 4" markerEnd="url(#arrow-dim)" />
      <text x="478" y="216" fontFamily="Raleway" fontSize="10" fill="#777">PII masked</text>
    </svg>
    <p className="diagram-caption">
      The bank's IdP stays canonical: the customer's session passes through the channel,
      into the Assistant, then into the Server, then into bank APIs. Langfuse receives
      anonymised signal only, used to improve all banks on the platform.
    </p>
  </div>
);
